import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import useIdentityStore from '@/store/IdentityStore';
import useSessionStore from '@/store/SessionStore';
import { getAuthUserInfo } from '../utils/aceIdentity';

const useAuthUserInfo = () => {
  const setUserInfo = useIdentityStore((state) => state.setUserInfo);
  const flowType = useSessionStore((state) => state.flowType);

  const userInfoQuery = useQuery({
    queryKey: ['authUserInfo'],
    queryFn: getAuthUserInfo,
    enabled: flowType === 'emailInquiry',
  });

  useEffect(() => {
    if (userInfoQuery.data) {
      const userInfo = userInfoQuery.data;
      setUserInfo(userInfo);
    }
  }, [userInfoQuery.data, setUserInfo]);

  return { userInfoQuery };
};

export default useAuthUserInfo;
